export default __webpack_public_path__ + "static/media/Logo_placeholder.c557b3a2.png";